import { Grid2 as Grid, Typography } from '@mui/material';
import React, { useContext, useEffect } from 'react';
import { BookingStore } from '../../../utils/stores/BookingStore';
import { ProductsStore } from '../../../utils/stores/ProductsStore';
import SelectPickUp from './SelectPickUp';
import { commonStyles } from './commonStyles';

export default function PickUpSection() {
    const bookingController = useContext(BookingStore);
    const productController = useContext(ProductsStore);
    const pickUpExists =
        productController.product?.pickupList &&
        productController.product.pickupList.slice(1, productController.product.pickupList.length).length > 0;
    const packagePickUpExists =
        productController.packageProduct.data?.pickupList &&
        productController.packageProduct.data.pickupList.slice(
            1,
            productController.packageProduct.data.pickupList.length
        ).length > 0;

    useEffect(() => {
        !pickUpExists && bookingController.resetPickUp();
        !packagePickUpExists && bookingController.resetPackagePickUp();
        return () => {
            pickUpExists && !bookingController.needPickUp && bookingController.resetPickUp();
            packagePickUpExists && !bookingController.needPackagePickUp && bookingController.resetPackagePickUp();
        };
    }, []);

    return (
        <Grid container sx={commonStyles.container}>
            <Typography variant="h5" sx={commonStyles.title}>
                {pickUpExists ? 'Transport & Check-In' : 'Check-In'}
            </Typography>
            <Typography sx={commonStyles.subtitle} style={{ paddingBottom: 10 }}>
                {pickUpExists
                    ? "Please select your transport option below. If you change your mind later on, that's cool, just get in touch with us and we'll update the booking for you."
                    : "Alright, now we just need to make sure that you're in the right place, at the right time."}
            </Typography>
            <Typography sx={commonStyles.subtitle}>
                We&apos;ll also include this info in your confirmation email.
            </Typography>
            {productController.product?.allowPackage && (
                <Typography variant="h6" style={{ marginBottom: 20, opacity: 0.9 }}>
                    First, let&apos;s organise the {bookingController.booking.packageProductNames[0]}
                </Typography>
            )}
            <SelectPickUp />
            {productController.product?.allowPackage && (
                <>
                    <Grid container direction="column" size={{ xs: 12 }}>
                        <Typography variant="h6" style={{ margin: '15px 0 20px', opacity: 0.9 }}>
                            Next, your {bookingController.booking.packageProductNames[1]}
                        </Typography>
                    </Grid>
                    <SelectPickUp isPackage={true} />
                </>
            )}
        </Grid>
    );
}
